import React from "react";
import PageShell from "../components/layout/PageShell";
import Gateway from "../features/home/Gateway";
import HeroSection from "../features/home/HeroSection";
import TrustSection from "../features/home/TrustSection";
import EcosystemSection from "../features/home/EcosystemSection";
import FeaturedCourses from "../features/home/FeaturedCourses";
import RoadmapSection from "../features/home/RoadmapSection";
import PlacementSection from "../features/home/PlacementSection";
import DashboardsSection from "../components/shared/DashboardsSection";
import KnowledgeSection from "../components/shared/KnowledgeSection";
import ArchitectureSection from "../components/shared/ArchitectureSection";
import SearchAssistant from "../components/shared/SearchAssistant";
import ContactSection from "../components/shared/ContactSection";
import EventsSection from "../features/home/EventsSection";
import Gatewaymodal  from "../components/shared/Gatewaymodal";
import TestimonialSection from "../features/home/TestimonialSection";
import TrainingSection from "../features/home/TrainingSection";

export default function HomePage() {
  return (
    <PageShell>
      <Gatewaymodal  />
      <Gateway />
      {/* <EventsSection /> */}
      <HeroSection />
      <TrustSection />
      <EcosystemSection />
      {/* <RoadmapSection /> */}
      <FeaturedCourses />
      <PlacementSection />
      <TestimonialSection/>
      <TrainingSection/>
      {/* <DashboardsSection /> */}
      {/* <KnowledgeSection /> */}
      {/* <ArchitectureSection /> */}
      {/* <SearchAssistant /> */}
      {/* <ContactSection /> */}
    </PageShell>
  );
}